import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "12",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M15.04 11.843H.959v-4.48h14.08zM15.04 5.16H.959v-2.3h14.08zM15.04 1.053H.959V.157h14.08z" })
    ], -1)
  ]))]))
}
export default { render: render }